import React from "react";
import { ButtonSeverity } from "../../types/types";
import { StyledButton } from "./styled";

interface ButtonProps {
  active?: boolean;
  label: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  style?: React.CSSProperties;
  severity?: ButtonSeverity;
  icon?: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  active = false,
  label,
  onClick,
  disabled = false,
  type = "button",
  style,
  severity = "primary",
  icon,
}) => {
  return (
    <StyledButton
      active={active}
      onClick={onClick}
      disabled={disabled}
      type={type}
      style={style}
      severity={severity}
    >
      {icon} {label}
    </StyledButton>
  );
};

export default Button;
